module.exports = __webpack_public_path__ + "img/mc.e30f04f3.svg";